export const getAcceptedAudioFiles = (files, fileTypes) =>
  Array.from(files).filter((file) =>
    fileTypes.some((extension) => extension === '*' || file.name.toLowerCase().endsWith(extension)),
  );

export const getAudioFileUploadError = (file, maxFileSize) =>
  file.size > maxFileSize ? 'File was too large. Please select a smaller file.' : '';

export const createAudioUploadFormData = (file, fileName, type, override = false) => {
  const formData = new FormData();
  formData.append('audio', file, `${fileName}.${type}`);
  formData.append('override', String(override));
  return formData;
};

export const getAudioDisplayName = (audio) => audio.displayName || audio.name || '(unnamed)';

export const getAudioNotificationSubject = (name) => (name ? `'${name}'` : 'Audio file');

export const formatAudioFileSize = (size, bytesPerMegabyte) =>
  `${(size / bytesPerMegabyte).toFixed(2)} MB`;

export const getAudioProgressPercentage = (completed, total) => (completed / total) * 100;
